import { PlusOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Drawer,
    Form,
    Input,
    Row,
    Select,
    Space,
    Spin
} from "antd";
import { Component } from "react";
import "../styles/general.css";

import { POST } from "../constants/request-type";
import { create_discount, discount } from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { openNotificationWithIcon } from "../functions/notification";

import logger from '../../utils/logger.js';
const token = sessionStorage.getItem("auth_token");

const { Option } = Select;

class Discount_new extends Component {
  state = {
    visible: false,
    use: 0,
    code: 0,
    type: "flat",
    locked: false,
    load: false
  };

  componentDidMount() {}
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ load: true });

    const { code, value, type, use } = this.state;

    const data = {
      code: code.toLowerCase(),
      value: value,
      use: use,
      type
    };

   

    const request_details = {
      type: POST,
      url: service_api,
      route: discount + "/" + create_discount,
      data: data,
      token: token
    };

    if (data.code.length === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "Vous devez remplir tous les champs"
      );
    }

    if (data.value === 0 || data.use === 0) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        "La valeur et le nombre d'utilisation doit être plus grand que zéro"
      );
    }

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 0);
    } catch (err) {
      logger.log(err);
      this.setState({ load: false });
      return openNotificationWithIcon("error", err);
    }
  };

  showDrawer = () => {
    this.setState({
      visible: true
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { code, value, use, type, load } = this.state;
    return (
      <>
        <Button type="primary" onClick={this.showDrawer}>
          <PlusOutlined /> Ajouter un code
        </Button>
        <Drawer
          title="Ajouter un code"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
          footer={
            <div
              style={{
                textAlign: "right"
              }}
            >
              {load ? (
                <Space size="middle">
                  <Spin size="large" />
                </Space>
              ) : (
                <div>
                  <Button onClick={this.onClose} style={{ marginRight: 8 }}>
                    Annuler
                  </Button>
                  <Button
                    onClick={(e) => {
                      this.handleSubmit(e);
                    }}
                    type="primary"
                  >
                    Soumettre
                  </Button>
                </div>
              )}
            </div>
          }
        >
          <Form layout="vertical" hideRequiredMark>
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="code"
                  label="Créer un code"
                  rules={[
                    {
                      required: true,
                      title: "Code"
                    }
                  ]}
                >
                  <Input
                    name="code"
                    placeholder="Code"
                    onChange={this.handleChange}
                    value={code}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Type de valeur"
                  rules={[
                    {
                      required: true,
                      role: "Veuillez selectionner le genre"
                    }
                  ]}
                >
                  <Select
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="Selectionner parmis les options"
                    defaultValue={type}
                    onChange={(data) => {
                      return this.setState({ type: data });
                    }}
                  >
                    {[
                      {
                        _id: "flat",
                        name: "valeur"
                      },
                      {
                        _id: "per",
                        name: "pourcentage"
                      }
                    ].map((item) => (
                      <Option key={item?._id}>
                        <span>{item?.name}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="value"
                  label="Valeur"
                  rules={[
                    {
                      required: true,
                      text: "Description"
                    }
                  ]}
                >
                  <Input
                    name="value"
                    placeholder="value"
                    type="number"
                    onChange={this.handleChange}
                    value={value}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="use"
                  label="Nombre d'utilisation"
                  rules={[
                    {
                      required: true,
                      text: "use"
                    }
                  ]}
                >
                  <Input
                    name="use"
                    placeholder="use"
                    type="number"
                    onChange={this.handleChange}
                    value={use}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Drawer>
      </>
    );
  }
}

export default Discount_new;
